export default __webpack_public_path__ + "static/media/dole-juice-bg@3x.e22775fa.png";